import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { GameSettingsProvider } from './hooks/useGameSettings';
import { ParticleSystemProvider } from './components/ParticleSystemProvider';
import MobileShellProvider from './components/shell/MobileShellProvider';
import { SimulatorProvider } from './contexts/SimulatorContext';
import { DeviceSimulatorWrapper } from './components/simulator/DeviceSimulatorWrapper';
import './styles/tailwind.css';

if (typeof window !== 'undefined' && 'serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error) => {
      console.warn('[sw] registration failed', error);
    });
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <GameSettingsProvider>
      <SimulatorProvider>
        <DeviceSimulatorWrapper>
          <MobileShellProvider>
            <ParticleSystemProvider>
              <App />
            </ParticleSystemProvider>
          </MobileShellProvider>
        </DeviceSimulatorWrapper>
      </SimulatorProvider>
    </GameSettingsProvider>
  </React.StrictMode>
);
